<div class="grid">
  <div class="lg:col-7 col-12">
    <p-card>
      <div class="p-fluid">
        <div class="field">
          <label class="font-medium required-field">Название</label>
          <crm-input-text
            [(value)]="deal.name"
            [isError]="$any(errors?.name)"></crm-input-text>
          <small
            *ngIf="errors?.name"
            class="p-error">
            {{ errors.name | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium required-field">Контрагент</label>
          <crm-contragent-auto-complete
            [withClients]="true"
            [(selectedContragent)]="deal.contragent"
            [customSearch]="false"
            [isError]="$any(errors?.contragent)"
            appendTo="body"></crm-contragent-auto-complete>
          <small
            *ngIf="errors?.contragent"
            class="p-error">
            {{ errors.contragent | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Компания</label>
          <crm-single-select
            [options]="companies"
            [(selectedItem)]="deal.company"
            [class]="errors?.company ? 'ng-invalid ng-dirty' : ''"
            [styleClass]="errors?.company ? 'ng-invalid ng-dirty' : ''"
            [showClear]="true"
            appendTo="body"></crm-single-select>
          <small
            *ngIf="errors?.company"
            class="p-error">
            {{ errors.company | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Дата отгрузки</label>
          <crm-datepicker
            [(value)]="deal.shippingDate"
            [inputStyleClass]="errors?.shippingDate ? 'ng-invalid ng-dirty' : ''"
            appendTo="body"></crm-datepicker>
          <small
            *ngIf="errors?.shippingDate"
            class="p-error">
            {{ errors.shippingDate | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Описание</label>
          <crm-editor
            [(value)]="deal.comment"
            height="110px"></crm-editor>
          <small
            *ngIf="errors?.comment"
            class="p-error">
            {{ errors.comment | join }}
          </small>
        </div>

        <div
          *ngIf="!canDelete"
          class="field">
          <label class="font-medium">Файлы</label>
          <div
            *ngIf="deal.files?.length"
            class="mb-2">
            <crm-files-list
              [files]="deal.files"
              [canDelete]="true"
              (deleteFile)="deleteFile(deal.files, $event)"></crm-files-list>
          </div>
          <p-fileUpload
            #fileUpload
            mode="basic"
            [customUpload]="true"
            chooseIcon="pi-paperclip"
            chooseLabel="Прикрепить файл"
            [disabled]="filesLoading"
            (uploadHandler)="uploadFiles($event)"
            [auto]="true">
          </p-fileUpload>
          <small
            *ngIf="errors?.files"
            class="p-error">
            {{ errors.files | join }}
          </small>
        </div>
      </div>
    </p-card>

    <div class="mt-3">
      <crm-deal-order-form
        [(orders)]="deal.orders"
        [errors]="errors?.orders"></crm-deal-order-form>
    </div>
  </div>

  <div class="lg:col-5 col-12">
    <p-card header="Дополнительные реквизиты">
      <div class="p-fluid">
        <div class="field">
          <label class="font-medium">Время план</label>
          <p-inputNumber
            [(ngModel)]="deal.plannedMin"
            [ngClass]="{ 'ng-invalid ng-dirty': errors?.plannedMin }"></p-inputNumber>
          <small
            *ngIf="errors?.plannedMin"
            class="p-error">
            {{ errors.plannedMin | join }}
          </small>
        </div>

        <div class="field">
          <label
            class="font-medium"
            [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.directionsRequired"
            >Бюджетная статья</label
          >
          <crm-direction-single-select
            [directions]="directions"
            [(selectedDirection)]="deal.direction"
            [groupsDisabled]="true"
            [styleClass]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
            [class]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
            appendTo="body">
          </crm-direction-single-select>
          <small
            *ngIf="errors?.direction"
            class="p-error">
            {{ errors.direction | join }}
          </small>
        </div>

        <div class="field">
          <label
            class="font-medium"
            [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.unitsRequired">
            Бизнес единица
          </label>
          <crm-unit-single-select
            [(selectedUnit)]="deal.unit"
            [isError]="$any(errors?.unit)"
            [showClear]="true"
            appendTo="body"></crm-unit-single-select>
          <small
            *ngIf="errors?.unit"
            class="p-error">
            {{ errors.unit | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Проект</label>
          <crm-single-select
            [options]="groups"
            [(selectedItem)]="deal.group"
            [showClear]="true"
            [class]="errors?.group ? 'ng-invalid ng-dirty' : ''"
            appendTo="body"></crm-single-select>
          <small
            *ngIf="errors?.group"
            class="p-error">
            {{ errors.group | join }}
          </small>
        </div>

        <div class="field">
          <label
            class="font-medium"
            [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.filialsRequired">
            Филиал
          </label>
          <crm-filial-single-select
            [(selectedFilial)]="deal.filial"
            [isError]="$any(errors?.filial)"
            appendTo="body"
            [showClear]="true"></crm-filial-single-select>
          <small
            *ngIf="errors?.filial"
            class="p-error">
            {{ errors.filial | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Приоритет</label>
          <crm-priority-single-select
            [(selectedPriority)]="deal.priority"
            [styleClass]="errors?.priority ? 'ng-invalid ng-dirty' : ''"
            [class]="errors?.priority ? 'ng-invalid ng-dirty' : ''"
            appendTo="body">
          </crm-priority-single-select>
          <small
            *ngIf="errors?.priority"
            class="p-error">
            {{ errors.priority | join }}
          </small>
        </div>
      </div>
    </p-card>

    <p-card
      header="Задача"
      styleClass="mt-3">
      <div class="p-fluid">
        <div class="field">
          <label class="font-medium">Задача</label>
          <crm-project-multi-select
            [projects]="projects"
            [(selectedProjects)]="deal.projects"
            [isError]="$any(errors?.projects)"
            appendTo="body">
          </crm-project-multi-select>
          <p
            *ngIf="errors?.projects"
            class="p-error">
            {{ errors.projects | join }}
          </p>
        </div>
      </div>
    </p-card>

    <p-card
      header="Заявка HD"
      styleClass="mt-3">
      <div class="p-fluid">
        <div class="field">
          <label class="font-medium">Заявка HelpDesk</label>
          <crm-hd-task-multi-select
            [tasks]="tasks"
            [(selectedTasks)]="deal.helpdeskTasks"
            [isError]="$any(errors?.helpdeskTasks)"
            appendTo="body"></crm-hd-task-multi-select>
          <p
            *ngIf="errors?.helpdeskTasks"
            class="p-error">
            {{ errors.helpdeskTasks | join }}
          </p>
        </div>
      </div>
    </p-card>

    <p-card
      header="Участники"
      styleClass="mt-3">
      <div class="field">
        <label class="font-medium">Ответственный</label>
        <crm-user-single-select
          [(selectedUser)]="deal.responsible"
          [isError]="$any(errors?.responsible)"
          [showClear]="true"
          appendTo="body"></crm-user-single-select>
        <small
          *ngIf="errors?.responsible"
          class="p-error">
          {{ errors.responsible | join }}
        </small>
      </div>

      <h3 class="font-medium -mb-2">Аудиторы</h3>
      <p-divider></p-divider>
      <div class="formgrid grid">
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Пользователи</label>
          <crm-user-multi-select
            [(selectedUsers)]="deal.userAuditors"
            [isError]="$any(errors?.userAuditors)"
            [isFloatLabel]="false"
            appendTo="body"></crm-user-multi-select>
          <p
            *ngIf="errors?.userAuditors"
            class="p-error">
            {{ errors.userAuditors | join }}
          </p>
        </div>

        <div class="field lg:col-6 col-12">
          <label class="font-medium">Группы</label>
          <crm-multi-select
            [(selectedItems)]="deal.groupAuditors"
            [options]="userGroups"
            appendTo="body"
            [class]="errors?.groupAuditors ? 'ng-invalid ng-dirty' : ''"
            [styleClass]="errors?.groupAuditors ? 'ng-invalid ng-dirty' : ''">
          </crm-multi-select>
          <p
            *ngIf="errors?.groupAuditors"
            class="p-error">
            {{ errors.groupAuditors | join }}
          </p>
        </div>
      </div>
    </p-card>
  </div>
</div>

<div class="grid mt-3">
  <div class="lg:col-7 col-12 flex flex-wrap justify-content-between">
    <div>
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success mr-2"
        (click)="onSave(deal)"></button>
      <crm-go-back-button
        *ngIf="!isModal"
        [route]="route"></crm-go-back-button>
    </div>
    <button
      *ngIf="canDelete"
      pButton
      [label]="'Удалить'"
      class="p-button-danger p-button-text"
      (click)="delete.emit(deal)"></button>
  </div>
</div>
